// src/components/RequestDemoCard.js
import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

const RequestDemoCard = ({ record, onEdit }) => {
  // Format date for better readability
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  return (
    <Card className="request-demo-card">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <small>ID: {record.id}</small>
        <div>
          <Button
            variant="primary"
            size="sm"
            onClick={() => onEdit(record)}
          >
            <FontAwesomeIcon icon={faEdit} /> Edit
          </Button>
        </div>
      </Card.Header>

      <Card.Body>
        <Card.Title>{record.name || 'No Name'}</Card.Title>
        <Card.Text as="div">
          <div className="row">
            <div className="col-md-6">
              <p><strong>Email:</strong> {record.email}</p>
              <p><strong>Company:</strong> {record.company || 'N/A'}</p>
              <p><strong>Phone:</strong> {record.countryCode} {record.phone || 'N/A'}</p>
              <p><strong>Enquiry Type:</strong> {record.enquiryType || 'N/A'}</p>
            </div>
            <div className="col-md-6">
              <p><strong>Message:</strong> {record.message || 'N/A'}</p>
              <p><strong>Created:</strong> {formatDate(record.created_at)}</p>
              <p><strong>Updated:</strong> {formatDate(record.updated_at)}</p>
            </div>
          </div>
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

export default RequestDemoCard;
